import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { grey } from "@mui/material/colors";

const FormTextarea = ({
  children,
  rows,
  textLimit,
  fieldProps,
  className,
  ...additionalProps
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div className={`${className}`} style={{ width: '100%' }}>
      <textarea
        className="form-group__textarea"
        rows={rows}
        style={{ 
          width: '100%',
          padding: '1rem',
          borderRadius: '4px',
          border: '1px solid #ccc',
          fontSize: '1.8rem',
          minHeight: isMobile ? '120px' : '100px',
          fontFamily: 'inherit',
          lineHeight: '1.5',
        }}
        {...fieldProps}
        {...additionalProps}
      >
        {children}
      </textarea>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          fontSize: { xs: "12px", sm: "12px" },
          color: grey[600],
          mt: 0.5,
        }}
      >
        {textLimit && (
          <p>
            {fieldProps.value.length} / {textLimit}
          </p>
        )}
      </Box>
    </div>
  );
};

export default FormTextarea;
